import method from './method';

export default {
    method: method.GET,
    baseUrl: null,
    endpoint: null,
    data: null,
    queryString: null,
    headers: { "Content-Type": "application/json; charset=utf-8" },
    timeout: 0,
    withCredentials: false,
    responseType: 'json',
    xsrf: {
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN'
    },
    auth: {
        username: null,
        password: null
    },
    bearerToken: null,
    transform: {
        request: data => JSON.stringify(data),
        response: data => data
    },
    onProgress: null,
    onBeforeSend: null,
    validateStatus: status => status >= 200 && status < 300,
    debug: false
};